import React from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";

import Loader from "components/atoms/loader/index.jsx";
import Header from "components/organisms/header/index.jsx";
import Footer from "components/organisms/footer/index.jsx";
import FormHero from "components/organisms/formHero/index.jsx";
import FormContent from "components/organisms/formContent/index.jsx";
import FormWizard from "components/organisms/formWizard/index.jsx";
import FormWizardStep from "components/molecules/formWizardStep/index.jsx";
import LinkingPosCheckout from "components/molecules/linkingPosCheckout";

import StartStep from "components/organisms/buyForm/start";
import PersonalInformationStep from "components/organisms/buyForm/personal";
import ContactInformationStep from "components/organisms/buyForm/contact";
import PaymentInformationStep from "components/organisms/buyForm/payment";
import ConfirmationInformationStep from "components/organisms/buyForm/confirmation";

import { fetchStockItem } from "actions/stock";
import { requestPurchase } from "actions/purchase";

import "./styles.scss";

class Buy extends React.Component {
  constructor(props) {
    super(props);

    this.props.fetch(props.match.params.id);

    this.state = {
      step: 0,
      purchase: {
        transactionNumber: 0,
        customer: {},
      },
      discount: null,
    };

    this.handleNextStep = this.handleNextStep.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.applyDiscount = this.applyDiscount.bind(this);
  }

  gotoStep(step) {
    if (step > this.state.step) {
      return;
    }

    this.setState({
      step: step,
    });
  }

  applyDiscount(coupon) {
    this.setState({ discount: coupon });
  }

  handleNextStep(e) {
    this.setState({
      step: this.state.step + 1,
    });
  }

  handleSubmit(data) {
    data.usedStockId = this.props.vehicle.id;
    data.paymentAmount = "5000";
    data.licensePlate = this.props.vehicle.license_plate;
    data.vehicle =
      this.props.vehicle.brand +
      " " +
      this.props.vehicle.name +
      " " +
      this.props.vehicle.version;
    data.coupon = this.state.discount ? this.state.discount.code : "";

    this.setState({
      purchase: data,
      step: this.state.step + 1,
    });

    this.props.purchase(data);
  }

  getStepState(step) {
    if (step === this.state.step) {
      return "active";
    } else if (step < this.state.step) {
      return "completed";
    }

    return "";
  }

  render() {
    const vehicle = this.props.vehicle,
      step = this.state.step;

    if (!vehicle) {
      return (
        <div>
          <Header />
          <Loader />
        </div>
      );
    }

    return (
      <div>
        <Helmet>
          <title>Reservar {vehicle.name} usado - Territorio Yacopini</title>
          <meta name="description" content="Reservar vehículo usado online" />
        </Helmet>
        <Header />
        <FormHero vehicle={vehicle} promotion={this.state.discount} />
        <FormContent>
          <FormWizard>
            <FormWizardStep
              name="Inicio"
              state={this.getStepState(0)}
              onClick={() => this.gotoStep(0)}
            />
            <FormWizardStep
              name="Datos Personales"
              state={this.getStepState(1)}
              onClick={() => this.gotoStep(1)}
            />
            <FormWizardStep
              name="Pago"
              state={this.getStepState(2)}
              onClick={() => this.gotoStep(2)}
            />
            <FormWizardStep
              name="Confirmar"
              state={this.getStepState(3)}
              onClick={() => this.gotoStep(3)}
            />
          </FormWizard>

          {step === 0 && (
            <StartStep vehicle={vehicle} onSubmit={this.handleNextStep} />
          )}

          {step === 1 && (
            <PersonalInformationStep onSubmit={this.handleNextStep} />
          )}

          {step === 2 && (
            <ContactInformationStep onSubmit={this.handleNextStep} />
          )}

          {step === 3 && (
            <PaymentInformationStep
              onSubmit={this.handleNextStep}
              applyDiscount={this.applyDiscount}
              vehicle={vehicle}
            />
          )}

          {step === 4 && (
            <ConfirmationInformationStep
              onSubmit={this.handleSubmit}
              vehicle={vehicle}
            />
          )}

          {step === 5 && (
            <LinkingPosCheckout
              company={this.props.vehicle.company.toLowerCase()}
              amount={"400000"}
            />
          )}
        </FormContent>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    vehicle: state.stock.item,
    isFetching: state.purchase.isFetching,
    transactionNumber: state.purchase.transactionNumber,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetch: (id) => {
      dispatch(fetchStockItem(id));
    },
    purchase: (data) => {
      dispatch(requestPurchase(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Buy);
